exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert.show[data-v-4512526c]{bottom:0}.alert.alert-danger[data-v-4512526c]{background-color:#f04e4e}.alert.alert-success[data-v-4512526c]{background-color:#6ebd26}.alert[data-v-4512526c]{margin-bottom:0;transition:.3s;position:fixed;bottom:-100px;text-align:center;color:#fff;width:100%;left:0;height:46px;display:flex;justify-content:center;align-items:center;z-index:99999}", ""]);

// exports
